import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel, Box,
  Button, Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  Stack,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useColorModeValue
} from "@chakra-ui/react";
import { EnderecoType } from "models/endereco_type";
import { ViaCepType } from "models/via_cep_type";
import { useEffect, useState } from "react";
import InputMask from "react-input-mask";

interface IAddressData {
  list: EnderecoType[] | undefined;
  textColor: string;
  cepRef: any;
  ruaRef: any;
  numeroRef: any;
  complementoRef: any;
  bairroRef: any;
  cidadeRef: any;
  estadoRef: any;
  principalRef: any;
  viaCepEnd : ViaCepType;
  loadCEP :(cep: string) => void;
  adicionarEnd: () => void;
  deleteEnd: (end: EnderecoType) => void;
}

const AddressData = ({
  list,
  textColor,
  cepRef,
  ruaRef,
  numeroRef,
  complementoRef,
  cidadeRef,
  estadoRef,
  principalRef,
  bairroRef,
  loadCEP,
  viaCepEnd,
  adicionarEnd,
  deleteEnd
}: IAddressData) => {

    const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");


      const [cep, setCep] = useState('');
      const [complemento, setComplemento] = useState('');
      const [numero, setNumero] = useState('');
      const [principal, setPrincipal] = useState(true);

      const changeCep = (cep : string) => {

        setCep(cep);
        cepRef.current = cep;
      }

      const changeNumero = (numero: string) => {
        setNumero(numero);
        numeroRef.current = numero;
      }

      const changeComplemento = (complemento : string) => {
        setComplemento(complemento);
        complementoRef.current = complemento;
      } 

      const changePrincipal = (principal: boolean) => {
        setPrincipal(principal);
        principalRef.current = principal;
      }

      const submitEnd = () => {
        adicionarEnd();
        setCep('');
        cepRef.current = '';
        setComplemento('');
        complementoRef.current = '';
        setNumero('');
        numeroRef.current = ''
        setPrincipal(false);
        principalRef.current = false;
       
      }

     
    useEffect(() => {

    }, [cep])  

  return (
    <AccordionItem>
      <h2>
        <AccordionButton>
          <Box flex="1" textAlign="left" color={"#422AFB"} fontWeight={"bold"}>
            Endereços
          </Box>
          <AccordionIcon color={"#422AFB"} />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        <SimpleGrid columns={4} spacing={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              CEP
            </FormLabel>
            <Input
              ref={cepRef}
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder={"Preencha o CEP"}
              value={cep}
              onChange={(e) => changeCep(e.target.value)}
              onBlur={(e) =>  loadCEP(e.target.value)}
              fontWeight="500"
              size="md"
              as={InputMask}
              mask={"99999-999"}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Rua
            </FormLabel>
            <Input
              ref={ruaRef}
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha a Rua"
              onChange={(e) => (ruaRef.current = e.target.value)}
              fontWeight="500"
              value={viaCepEnd?.logradouro}
              disabled
              size="md"
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Número
            </FormLabel>
            <Input
              ref={numeroRef}
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o Número"
              onChange={(e) => changeNumero(e.target.value)}
              fontWeight="500"
              size="md"
              value={numero}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Complemento
            </FormLabel>
            <Input
              ref={complementoRef}
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o Complemento"
              onChange={(e) => changeComplemento(e.target.value)}
              fontWeight="500"
              value={complemento}
              size="md"
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              
              mb="8px"
            >
              Bairro
            </FormLabel>
            <Input
              ref={bairroRef}
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o Bairro"
              onChange={(e) => (bairroRef.current = e.target.value)}
              fontWeight="500"
              disabled
              value={viaCepEnd?.bairro}
              size="md"
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Cidade
            </FormLabel>
            <Input
              ref={cidadeRef}
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o Cidade"
              onChange={(e) => (cidadeRef.current = e.target.value)}
              fontWeight="500"
              disabled
              value={viaCepEnd?.localidade}
              size="md"
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Estado
            </FormLabel>
            <Input
              ref={cidadeRef}
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o Estado"
              onChange={(e) => (estadoRef.current = e.target.value)}
              fontWeight="500"
              disabled
              value={viaCepEnd?.uf}
              size="md"
            />
          </FormControl>


          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Endereço 
            </FormLabel>

            <Select
              placeholder="Selecione se o endereço é o principal"
              size="md"
              onChange={(e) => changePrincipal(Boolean(e.target.value))}
              ref={principalRef}
            >
              <option value="false">Não</option>
              <option value="true">Sim
              </option>

            </Select>
          </FormControl>
        </SimpleGrid>
        <Stack>
          <Button
            marginY={10}
            variant={'outline'}
            onClick={() => {submitEnd();}}
            alignSelf={"flex-end"}
            colorScheme="brand"
            isLoading={false}
          >
            Adicionar Endereço
          </Button>
        </Stack>

        <Box>
          <Table variant="striped" color="gray.500" mb="24px" mt="12px">
            <Thead>
              <Tr>
                
                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                  >
                      #ENDEREÇO
                  </Flex>
                  </Th>

                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                  >
                      #BAIRRO
                  </Flex>
                  </Th>

                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                  >
                      #CIDADE
                  </Flex>
                  </Th>
                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                  >
                      #PRINCIPAL
                  </Flex>
                  </Th>

                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                  >
                      #OPÇÕES
                  </Flex>
                  </Th>
              </Tr>
            </Thead>
            <Tbody>
              {list?.map((item, index) => {
                return (
                  <Tr key={`${item.id}-${item}-${index}`}>

                    <Td
                      fontSize={{ sm: "14px" }}
                      borderColor="transparent"
                    >
                      {item.local} -  {item.numero} {item.complemento}
                    </Td>
                    <Td
                      fontSize={{ sm: "14px" }}
                      borderColor="transparent"
                    >
                      {item.bairro}
                    </Td>
                    <Td
                      fontSize={{ sm: "14px" }}
                      borderColor="transparent"
                    >
                      {item.cidade} - {item.estado}
                    </Td>

                    <Td
                      
                      fontSize={{ sm: "14px" }}
                      borderColor="transparent"
                    >
                      {item.principal === true ? "SIM" : "NÃO"}
                    </Td>
                    <Td
                      fontSize={{ sm: "14px" }}
                      borderColor="transparent"
                    >
                  <Button onClick={() => { deleteEnd(item)}} colorScheme="red" variant="ghost" ml="1">
                        Excluir
                  </Button>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
  
        
        </Box>

        
      </AccordionPanel>
    </AccordionItem>


  );
};
export default AddressData;
